import { API } from "../utils/constants";
import { makeApiCall } from "./api-service";

type WidgetServiceParams = {
    bodyParams: any;
    urlParams?: string;
    method?: 'GET' | 'PUT' | 'POST' | 'DELETE';
    withUserId?: boolean;
    responseType?: 'JSON' | 'string' | 'blob';
}

export const widgetService = async ({ urlParams, bodyParams, method = 'POST', withUserId = true, responseType = "JSON" }: WidgetServiceParams): Promise<any> => {
    const URL = urlParams ? `${API.BASE_URL}/monitor/api/${urlParams}` : `${API.BASE_URL}/monitor/api`;
    const { status, response } = await makeApiCall(URL, method, bodyParams, withUserId);
    return responseType === "blob" ? response?.blob : responseType === 'string' ? response : status ? response?.json() : response;
}